import React, { useState } from 'react';
import { useMediaQuery } from '@mui/material';

const WHATSAPP_NUMBER = '27630573914';
const PREFILLED_MESSAGE = 'Hello! I would like to chat with you about your services.';

const WhatsAppFloat = () => {
    const [hovered, setHovered] = useState(false);
    // Bottom nav is visible on screens below lg (1200px)
    const hasMobileNav = useMediaQuery('(max-width:1199px)');

    const handleClick = () => {
        const encoded = encodeURIComponent(PREFILLED_MESSAGE);
        window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encoded}`, '_blank', 'noopener,noreferrer');
    };

    return (
        <div
            style={{
                position: 'fixed',
                bottom: hasMobileNav ? '72px' : '24px',
                right: '16px',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                flexDirection: 'row-reverse',
            }}
        >
            {/* Bubble button */}
            <button
                onClick={handleClick}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                aria-label="Chat with us on WhatsApp"
                style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    backgroundColor: '#25D366',
                    border: 'none',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: hovered
                        ? '0 6px 20px rgba(37, 211, 102, 0.55)'
                        : '0 4px 14px rgba(37, 211, 102, 0.4)',
                    transform: hovered ? 'scale(1.1)' : 'scale(1)',
                    transition: 'all 0.2s ease',
                    flexShrink: 0,
                }}
            >
                {/* WhatsApp SVG icon */}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    width="30"
                    height="30"
                    fill="white"
                >
                    <path d="M16 0C7.164 0 0 7.163 0 16c0 2.824.737 5.47 2.027 7.773L0 32l8.448-2.01A15.93 15.93 0 0016 32c8.836 0 16-7.163 16-16S24.836 0 16 0zm0 29.333a13.267 13.267 0 01-6.758-1.847l-.484-.286-5.014 1.194 1.236-4.884-.314-.503A13.22 13.22 0 012.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.27-9.874c-.397-.199-2.353-1.161-2.718-1.294-.364-.132-.63-.199-.895.199-.265.397-1.028 1.294-1.26 1.56-.232.265-.464.298-.862.1-.397-.2-1.677-.618-3.194-1.97-1.18-1.052-1.977-2.35-2.21-2.748-.231-.397-.025-.612.174-.809.178-.177.397-.464.596-.696.199-.232.265-.397.397-.662.133-.265.067-.497-.033-.696-.1-.199-.895-2.158-1.228-2.956-.323-.776-.65-.67-.895-.683l-.762-.013c-.265 0-.696.1-1.06.497-.364.397-1.39 1.36-1.39 3.314s1.423 3.845 1.621 4.11c.199.265 2.8 4.277 6.78 5.995.948.41 1.688.654 2.265.838.951.303 1.817.26 2.502.157.763-.113 2.353-.962 2.685-1.89.331-.926.331-1.72.232-1.889-.099-.166-.364-.265-.762-.464z" />
                </svg>
            </button>

            {/* Tooltip label */}
            <div
                style={{
                    backgroundColor: '#25D366',
                    color: '#fff',
                    padding: '8px 14px',
                    borderRadius: '20px',
                    fontSize: '14px',
                    fontWeight: '600',
                    whiteSpace: 'nowrap',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
                    opacity: hovered ? 1 : 0,
                    transform: hovered ? 'translateX(0)' : 'translateX(10px)',
                    transition: 'opacity 0.2s ease, transform 0.2s ease',
                    pointerEvents: 'none',
                    userSelect: 'none',
                }}
            >
                Chat with us
            </div>
        </div>
    );
};

export default WhatsAppFloat;
